/* eslint-disable react/no-danger */
import React from 'react';
import classNames from 'classnames';

import { Tappable } from '@common/ui/general';

import { useChatbotContext } from '~chatbot/context/ChatbotContext';

import closeIcon from '~chatbot/assets/chatbot-close.svg';
import scalerIcon from '~chatbot/assets/scaler-icon.svg';
import RequestCallback from '../RequestCallback';
import styles from './ChatbotHeader.module.scss';

function ChatbotHeaderTitle({
  header,
  chatbotHeader,
  showDescription,
  contactEmail,
}) {
  if (header) {
    return (
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: header }}
      />
    );
  }

  return (
    <div className={styles.title}>
      <span>{chatbotHeader}</span>

      {showDescription && (
        <p className={styles.headerDescription}>
          Feel free to contact us at
          {' '}
          <a href={`mailto:${contactEmail}`}>
            {contactEmail}
          </a>
        </p>
      )}
    </div>
  );
}

function ChatbotHeader({
  header,
  logo,
  extraClass,
  handleTracking,
}) {
  const { setisOpenWidget, config } = useChatbotContext();
  const {
    showDescription,
    contactEmail,
    chatbotHeader,
    showRcbOption,
  } = config;

  const handleChatBot = () => {
    setisOpenWidget(false);
    handleTracking({
      click_type: 'button_click',
      click_text: '',
      element: 'Close Icon',
    });
  };

  return (
    <div className={classNames(
      styles.headerWrapper,
      { [styles.extraClass]: !!extraClass },
    )}
    >
      <div className={classNames(
        styles.headerContent,
        { [styles.extraClass]: !!extraClass },
      )}
      >
        <img src={logo || scalerIcon} alt="header" />
        <ChatbotHeaderTitle
          header={header}
          chatbotHeader={chatbotHeader}
          showDescription={showDescription}
          contactEmail={contactEmail}
        />
        {showRcbOption && (
          <RequestCallback className={styles.headerRCB} />
        )}
      </div>
      <Tappable
        onClick={handleChatBot}
      >
        <img src={closeIcon} alt="header" className={styles.closeModal} />
      </Tappable>
    </div>
  );
}

export default ChatbotHeader;
